import { API_BASE_URL } from "constants/apiBase";

export type DonationResult = "thanks" | "cancelled";

/** `ibonn://donation/thanks?d=…&t=…` (eller `cancelled`). Uten d/t: bare stien. */
export const appDeepLink = (
  result: DonationResult,
  d?: string | null,
  t?: string | null,
) => {
  const path = `ibonn://donation/${result}`;
  return d && t
    ? `${path}?d=${encodeURIComponent(d)}&t=${encodeURIComponent(t)}`
    : path;
};

/** Offentlig, beskyttet med status-tokenet `t`. */
export const donationStatusUrl = (d: string, t: string) =>
  `${API_BASE_URL}/api/v1/donations/${encodeURIComponent(
    d,
  )}/status?t=${encodeURIComponent(t)}`;

export type DonationStatusKind =
  | "paid"
  | "pending"
  | "failed"
  | "cancelled"
  | "unknown";

export interface DonationStatusView {
  kind: DonationStatusKind;
  /** Beløp i øre, hvis serveren sendte det. */
  amountOre: number | null;
  campaignName: string | null;
  monthly: boolean;
}

const num = (v: unknown) =>
  typeof v === "number" && Number.isFinite(v) ? v : null;
const str = (v: unknown) => (typeof v === "string" && v.trim() ? v : null);

/**
 * Leser svaret fra status-endepunktet. Tåler litt ulike feltnavn
 * (`amountOre` i øre, eller `amount` i kroner; `campaignName` eller
 * `campaign.name`). STOPPED (fast gave som ble avbrutt i Vipps) gir `cancelled`.
 * Ukjent form gir `unknown`.
 */
export const parseDonationStatus = (body: unknown): DonationStatusView => {
  const b = (body && typeof body === "object" ? body : {}) as Record<
    string,
    any
  >;
  const status = String(b.status ?? "").toUpperCase();
  const kind: DonationStatusKind =
    status === "PAID" || status === "ACTIVE"
      ? "paid"
      : status === "PENDING"
        ? "pending"
        : status === "FAILED"
          ? "failed"
          : status === "STOPPED"
            ? "cancelled"
            : "unknown";
  const ore = num(b.amountOre);
  const kroner = num(b.amount);
  return {
    kind,
    amountOre: ore ?? (kroner != null ? Math.round(kroner * 100) : null),
    campaignName:
      str(b.campaignName) ?? str(b.campaign?.name) ?? str(b.campaign),
    monthly: String(b.interval ?? "").toUpperCase() === "MONTHLY",
  };
};

/** Åpner appen (egen funksjon så testene kan fange den). */
export const openDeepLink = (url: string) => {
  window.location.href = url;
};

export const POLL_INTERVAL_MS = 3000;
export const POLL_MAX_MS = 30000;
export const DEEP_LINK_DELAY_MS = 600;
